export class TaskLogParams {
  in_progress: string;
  order: number;
  task: number;
}
